import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[customColumnTemplate]'
})
export class CustomColumnTemplateDirective {
  @Input('columnKey') columnKey!: string;

  constructor(public templateRef: TemplateRef<any>) {}
}